import {
    FETCH_PLAYERS,
    FETCH_PLAYERS_FAIL,
    FETCH_PLAYERS_SUCCESS
} from './actionTypes';
import {
    defaultFirstPage,
    defaultItemsPerPage
} from '../../../../services/Paging';

const initialState = {
    data: [],
    pagination: {
        pageSize: defaultItemsPerPage,
        page: defaultFirstPage,
        hasNextPage: false
    },
    error: null,
    loading: false,
    loaded: false
};

export function playersReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_PLAYERS: {
            const { pageSize, page, username } = action.payload;

            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    pageSize: pageSize || state.pagination.pageSize,
                    page: page || state.pagination.page
                },
                username: state.username || username,
                loading: true
            };
        }
        case FETCH_PLAYERS_SUCCESS: {
            return {
                ...state,
                data: action.payload.result,
                pagination: {
                    ...state.pagination,
                    hasNextPage: action.payload.hasNext
                },
                loaded: true,
                loading: false
            };
        }
        case FETCH_PLAYERS_FAIL: {
            return {
                ...initialState,
                error: action.payload
            };
        }
        default:
            return state;
    }
}
